
import { Component, Vue } from "vue-property-decorator";
import NotificationTemplate from "@/components/NotificationTemplate/NotificationTemplate.vue";

const ICON = "alert-circle-outline";

@Component({
  components: {
    NotificationTemplate,
  },
})
export default class NotificationNotLoaded extends Vue {
  icon = ICON;

  emitEvent() {
    this.$emit("onEvent");
  }
}
